import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import FormModal from '../../../../components/Admin/FormModal/FormModal';
import FormFieldClass from '../../../../components/Admin/FormModal/FormFieldClass';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './ListAssetCollections.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListAssetCollections extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToEdit = this.goToEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.delete = this.delete.bind(this);
        this.collectionSubmit = this.collectionSubmit.bind(this);
        this.collectionToggle = this.collectionToggle.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToEdit(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'asset_collections/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async delete(row) {
        console.log(row.rowData.id);

        const retVal = confirm("Do you want to continue ?");
    
        if(retVal === true) {
                  console.log('delete accepted');
                  const res = await this.props.services.adminAPI.deleteItemGeneral( 'asset_collections',row.rowData.id);
                  if (res.ok) {
                    
                    const assetCollectionsRes = await this.props.services.adminAPI.getAssetCollectionsOverview();

                    if (assetCollectionsRes.ok) {
            
                        const collections = assetCollectionsRes.data.asset_collections;
                        
                        const data = this.state.data;

                        data.collections = collections;

                        this.setState({data});
                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.goToEdit(props)}>Edit</button>

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.delete(props)}>Delete</button>
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["id", "Title", "Description", "Created", "Creator","delete"];
        
        const assetCollectionsThead = ["ID", "Name", "Description", "Date", "Creator", "Action"];

        const collectionFormFields = [
            {
                id: 'Name',
                name: 'Name',
                type: 'text',
                placeholder: 'Enter Name',
                required: true
            },
            {
                id: 'Description',
                name: 'Description',
                type: 'text',
                placeholder: 'Enter Description',
                required: true
            }
        ] as FormFieldClass[];

        const collectionFormValues = {
            Description: '',
            isAdminAsset: false,
            User: currentUserID,
            Name: '',
        }

        const assetCollectionsRes = await adminAPI.getAssetCollectionsOverview();

        if (assetCollectionsRes.ok) {
            
            const collections = assetCollectionsRes.data.asset_collections;

            this.setState(
                {
                     data: {
                        collections,
                        loaded: true,
                        collectionFormFields,
                        collectionFormValues,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public collectionToggle() {
        const data = this.state.data
        data.collectionModal = !data.collectionModal;
        this.setState({
            data
         });
    }

    public async collectionSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.collectionFormValues;

        const res = await this.props.services.adminAPI.createItemGeneral('asset_collections', item);

        if (res.ok) {
            this.collectionToggle();

            const collectionsRes = await this.props.services.adminAPI.getAssetCollectionsOverview();
            
            if(collectionsRes.ok) {
                const data = this.state.data;

                data.collections = collectionsRes.data.asset_collections;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <Button onClick={this.collectionToggle}>Add New</Button>
                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "edit", sortable: false },
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

              <ContentRow>
            
                    <FormModal 
                        visible={data.collectionModal}
                        toggle={this.collectionToggle}
                        formsubmit={this.collectionSubmit}
                        formfields = {data.collectionFormFields}
                        values={data.collectionFormValues}
                        isbusy={!this.state.loaded}
                    />
                    
                </ContentRow>

              
              </Wrapper>
        );

    }

}

export default withServices(ListAssetCollections);


// WEBPACK FOOTER //
// ./src/pages/Admin/AssetCollections/ListAssetCollections/ListAssetCollections.tsx